export default "__VITE_ASSET__bu6u_rhe__"